import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, Output, ContentChildren, forwardRef } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, CollectionNestedOption } from 'devextreme-angular/core';

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeAnimationComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeAnimationComponent extends NestedOption {
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeAnimationComponent,
      selectors: [["dxo-circular-gauge-animation"]],
      inputs: {
        duration: "duration",
        easing: "easing",
        enabled: "enabled"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeAnimationComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeAnimationModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeAnimationModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeBackgroundColorComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeBackgroundColorComponent extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    get _optionPath() {
      return 'backgroundColor';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeBackgroundColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeBackgroundColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeBackgroundColorComponent,
      selectors: [["dxo-circular-gauge-background-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeBackgroundColorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeBackgroundColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeBackgroundColorModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeBackgroundColorModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeBackgroundColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeBackgroundColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeBackgroundColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeBackgroundColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeBorderComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeBorderComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get dashStyle() {
      return this._getOption('dashStyle');
    }
    set dashStyle(value) {
      this._setOption('dashStyle', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'border';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeBorderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeBorderComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeBorderComponent,
      selectors: [["dxo-circular-gauge-border"]],
      inputs: {
        color: "color",
        dashStyle: "dashStyle",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeBorderComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeBorderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeBorderModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeBorderModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeBorderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeBorderModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeBorderModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeBorderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeColorComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeColorComponent extends NestedOption {
    get base() {
      return this._getOption('base');
    }
    set base(value) {
      this._setOption('base', value);
    }
    get fillId() {
      return this._getOption('fillId');
    }
    set fillId(value) {
      this._setOption('fillId', value);
    }
    get _optionPath() {
      return 'color';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeColorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeColorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeColorComponent,
      selectors: [["dxo-circular-gauge-color"]],
      inputs: {
        base: "base",
        fillId: "fillId"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeColorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeColorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeColorModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeColorModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeColorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeColorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeColorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeColorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeExportComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeExportComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get fileName() {
      return this._getOption('fileName');
    }
    set fileName(value) {
      this._setOption('fileName', value);
    }
    get formats() {
      return this._getOption('formats');
    }
    set formats(value) {
      this._setOption('formats', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get printingEnabled() {
      return this._getOption('printingEnabled');
    }
    set printingEnabled(value) {
      this._setOption('printingEnabled', value);
    }
    get svgToCanvas() {
      return this._getOption('svgToCanvas');
    }
    set svgToCanvas(value) {
      this._setOption('svgToCanvas', value);
    }
    get _optionPath() {
      return 'export';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeExportComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeExportComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeExportComponent,
      selectors: [["dxo-circular-gauge-export"]],
      inputs: {
        backgroundColor: "backgroundColor",
        enabled: "enabled",
        fileName: "fileName",
        formats: "formats",
        margin: "margin",
        printingEnabled: "printingEnabled",
        svgToCanvas: "svgToCanvas"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeExportComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeExportComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeExportModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeExportModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeExportModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeExportModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeExportModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeExportModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeFontComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeFontComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get family() {
      return this._getOption('family');
    }
    set family(value) {
      this._setOption('family', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get weight() {
      return this._getOption('weight');
    }
    set weight(value) {
      this._setOption('weight', value);
    }
    get _optionPath() {
      return 'font';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeFontComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeFontComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeFontComponent,
      selectors: [["dxo-circular-gauge-font"]],
      inputs: {
        color: "color",
        family: "family",
        opacity: "opacity",
        size: "size",
        weight: "weight"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeFontComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeFontComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeFontModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeFontModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeFontModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeFontModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeFontModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeFontModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeFormatComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeFormatComponent extends NestedOption {
    get currency() {
      return this._getOption('currency');
    }
    set currency(value) {
      this._setOption('currency', value);
    }
    get formatter() {
      return this._getOption('formatter');
    }
    set formatter(value) {
      this._setOption('formatter', value);
    }
    get parser() {
      return this._getOption('parser');
    }
    set parser(value) {
      this._setOption('parser', value);
    }
    get precision() {
      return this._getOption('precision');
    }
    set precision(value) {
      this._setOption('precision', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get useCurrencyAccountingStyle() {
      return this._getOption('useCurrencyAccountingStyle');
    }
    set useCurrencyAccountingStyle(value) {
      this._setOption('useCurrencyAccountingStyle', value);
    }
    get _optionPath() {
      return 'format';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeFormatComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeFormatComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeFormatComponent,
      selectors: [["dxo-circular-gauge-format"]],
      inputs: {
        currency: "currency",
        formatter: "formatter",
        parser: "parser",
        precision: "precision",
        type: "type",
        useCurrencyAccountingStyle: "useCurrencyAccountingStyle"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeFormatComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeFormatComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeFormatModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeFormatModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeFormatModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeFormatModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeFormatModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeFormatModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeGeometryComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeGeometryComponent extends NestedOption {
    get endAngle() {
      return this._getOption('endAngle');
    }
    set endAngle(value) {
      this._setOption('endAngle', value);
    }
    get startAngle() {
      return this._getOption('startAngle');
    }
    set startAngle(value) {
      this._setOption('startAngle', value);
    }
    get _optionPath() {
      return 'geometry';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeGeometryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeGeometryComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeGeometryComponent,
      selectors: [["dxo-circular-gauge-geometry"]],
      inputs: {
        endAngle: "endAngle",
        startAngle: "startAngle"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeGeometryComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeGeometryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeGeometryModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeGeometryModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeGeometryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeGeometryModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeGeometryModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeGeometryModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeLabelComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeLabelComponent extends NestedOption {
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get hideFirstOrLast() {
      return this._getOption('hideFirstOrLast');
    }
    set hideFirstOrLast(value) {
      this._setOption('hideFirstOrLast', value);
    }
    get indentFromTick() {
      return this._getOption('indentFromTick');
    }
    set indentFromTick(value) {
      this._setOption('indentFromTick', value);
    }
    get overlappingBehavior() {
      return this._getOption('overlappingBehavior');
    }
    set overlappingBehavior(value) {
      this._setOption('overlappingBehavior', value);
    }
    get useRangeColors() {
      return this._getOption('useRangeColors');
    }
    set useRangeColors(value) {
      this._setOption('useRangeColors', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'label';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeLabelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeLabelComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeLabelComponent,
      selectors: [["dxo-circular-gauge-label"]],
      inputs: {
        customizeText: "customizeText",
        font: "font",
        format: "format",
        hideFirstOrLast: "hideFirstOrLast",
        indentFromTick: "indentFromTick",
        overlappingBehavior: "overlappingBehavior",
        useRangeColors: "useRangeColors",
        visible: "visible"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeLabelComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeLabelModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeLabelModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeLabelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeLabelModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeLabelModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeLabelModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeLoadingIndicatorComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeLoadingIndicatorComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showChange;
    get _optionPath() {
      return 'loadingIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'showChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeLoadingIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeLoadingIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeLoadingIndicatorComponent,
      selectors: [["dxo-circular-gauge-loading-indicator"]],
      inputs: {
        backgroundColor: "backgroundColor",
        font: "font",
        show: "show",
        text: "text"
      },
      outputs: {
        showChange: "showChange"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeLoadingIndicatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeLoadingIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeLoadingIndicatorModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeLoadingIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeLoadingIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeLoadingIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeLoadingIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeLoadingIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeMarginComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeMarginComponent extends NestedOption {
    get bottom() {
      return this._getOption('bottom');
    }
    set bottom(value) {
      this._setOption('bottom', value);
    }
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get right() {
      return this._getOption('right');
    }
    set right(value) {
      this._setOption('right', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'margin';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeMarginComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeMarginComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeMarginComponent,
      selectors: [["dxo-circular-gauge-margin"]],
      inputs: {
        bottom: "bottom",
        left: "left",
        right: "right",
        top: "top"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeMarginComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeMarginComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeMarginModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeMarginModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeMarginModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeMarginModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeMarginModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeMarginModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeMinorTickComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeMinorTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'minorTick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeMinorTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeMinorTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeMinorTickComponent,
      selectors: [["dxo-circular-gauge-minor-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeMinorTickComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeMinorTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeMinorTickModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeMinorTickModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeMinorTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeMinorTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeMinorTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeMinorTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiCircularGaugeRangeComponent = /*#__PURE__*/(() => {
  class DxiCircularGaugeRangeComponent extends CollectionNestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get _optionPath() {
      return 'ranges';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiCircularGaugeRangeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCircularGaugeRangeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiCircularGaugeRangeComponent,
      selectors: [["dxi-circular-gauge-range"]],
      inputs: {
        color: "color",
        endValue: "endValue",
        startValue: "startValue"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxiCircularGaugeRangeComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxiCircularGaugeRangeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiCircularGaugeRangeModule = /*#__PURE__*/(() => {
  class DxiCircularGaugeRangeModule {
    /** @nocollapse */static ɵfac = function DxiCircularGaugeRangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiCircularGaugeRangeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiCircularGaugeRangeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxiCircularGaugeRangeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeRangeContainerComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeRangeContainerComponent extends NestedOption {
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get paletteExtensionMode() {
      return this._getOption('paletteExtensionMode');
    }
    set paletteExtensionMode(value) {
      this._setOption('paletteExtensionMode', value);
    }
    get ranges() {
      return this._getOption('ranges');
    }
    set ranges(value) {
      this._setOption('ranges', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'rangeContainer';
    }
    get rangesChildren() {
      return this._getOption('ranges');
    }
    set rangesChildren(value) {
      this.setChildren('ranges', value);
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeRangeContainerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeRangeContainerComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeRangeContainerComponent,
      selectors: [["dxo-circular-gauge-range-container"]],
      contentQueries: function DxoCircularGaugeRangeContainerComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiCircularGaugeRangeComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rangesChildren = _t);
        }
      },
      inputs: {
        backgroundColor: "backgroundColor",
        offset: "offset",
        orientation: "orientation",
        palette: "palette",
        paletteExtensionMode: "paletteExtensionMode",
        ranges: "ranges",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeRangeContainerComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeRangeContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeRangeContainerModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeRangeContainerModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeRangeContainerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeRangeContainerModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeRangeContainerModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeRangeContainerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeScaleComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeScaleComponent extends NestedOption {
    get allowDecimals() {
      return this._getOption('allowDecimals');
    }
    set allowDecimals(value) {
      this._setOption('allowDecimals', value);
    }
    get customMinorTicks() {
      return this._getOption('customMinorTicks');
    }
    set customMinorTicks(value) {
      this._setOption('customMinorTicks', value);
    }
    get customTicks() {
      return this._getOption('customTicks');
    }
    set customTicks(value) {
      this._setOption('customTicks', value);
    }
    get endValue() {
      return this._getOption('endValue');
    }
    set endValue(value) {
      this._setOption('endValue', value);
    }
    get label() {
      return this._getOption('label');
    }
    set label(value) {
      this._setOption('label', value);
    }
    get minorTick() {
      return this._getOption('minorTick');
    }
    set minorTick(value) {
      this._setOption('minorTick', value);
    }
    get minorTickInterval() {
      return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value) {
      this._setOption('minorTickInterval', value);
    }
    get orientation() {
      return this._getOption('orientation');
    }
    set orientation(value) {
      this._setOption('orientation', value);
    }
    get scaleDivisionFactor() {
      return this._getOption('scaleDivisionFactor');
    }
    set scaleDivisionFactor(value) {
      this._setOption('scaleDivisionFactor', value);
    }
    get startValue() {
      return this._getOption('startValue');
    }
    set startValue(value) {
      this._setOption('startValue', value);
    }
    get tick() {
      return this._getOption('tick');
    }
    set tick(value) {
      this._setOption('tick', value);
    }
    get tickInterval() {
      return this._getOption('tickInterval');
    }
    set tickInterval(value) {
      this._setOption('tickInterval', value);
    }
    get _optionPath() {
      return 'scale';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeScaleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeScaleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeScaleComponent,
      selectors: [["dxo-circular-gauge-scale"]],
      inputs: {
        allowDecimals: "allowDecimals",
        customMinorTicks: "customMinorTicks",
        customTicks: "customTicks",
        endValue: "endValue",
        label: "label",
        minorTick: "minorTick",
        minorTickInterval: "minorTickInterval",
        orientation: "orientation",
        scaleDivisionFactor: "scaleDivisionFactor",
        startValue: "startValue",
        tick: "tick",
        tickInterval: "tickInterval"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeScaleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeScaleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeScaleModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeScaleModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeScaleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeScaleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeScaleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeScaleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeShadowComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeShadowComponent extends NestedOption {
    get blur() {
      return this._getOption('blur');
    }
    set blur(value) {
      this._setOption('blur', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get offsetX() {
      return this._getOption('offsetX');
    }
    set offsetX(value) {
      this._setOption('offsetX', value);
    }
    get offsetY() {
      return this._getOption('offsetY');
    }
    set offsetY(value) {
      this._setOption('offsetY', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get _optionPath() {
      return 'shadow';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeShadowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeShadowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeShadowComponent,
      selectors: [["dxo-circular-gauge-shadow"]],
      inputs: {
        blur: "blur",
        color: "color",
        offsetX: "offsetX",
        offsetY: "offsetY",
        opacity: "opacity"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeShadowComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeShadowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeShadowModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeShadowModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeShadowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeShadowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeShadowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeShadowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeSizeComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeSizeComponent extends NestedOption {
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'size';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeSizeComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeSizeComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeSizeComponent,
      selectors: [["dxo-circular-gauge-size"]],
      inputs: {
        height: "height",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeSizeComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeSizeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeSizeModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeSizeModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeSizeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeSizeModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeSizeModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeSizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeSubtitleComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeSubtitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'subtitle';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeSubtitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeSubtitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeSubtitleComponent,
      selectors: [["dxo-circular-gauge-subtitle"]],
      inputs: {
        font: "font",
        offset: "offset",
        text: "text",
        textOverflow: "textOverflow",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeSubtitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeSubtitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeSubtitleModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeSubtitleModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeSubtitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeSubtitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeSubtitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeSubtitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeSubvalueIndicatorComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeSubvalueIndicatorComponent extends NestedOption {
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get baseValue() {
      return this._getOption('baseValue');
    }
    set baseValue(value) {
      this._setOption('baseValue', value);
    }
    get beginAdaptingAtRadius() {
      return this._getOption('beginAdaptingAtRadius');
    }
    set beginAdaptingAtRadius(value) {
      this._setOption('beginAdaptingAtRadius', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get indentFromCenter() {
      return this._getOption('indentFromCenter');
    }
    set indentFromCenter(value) {
      this._setOption('indentFromCenter', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get secondColor() {
      return this._getOption('secondColor');
    }
    set secondColor(value) {
      this._setOption('secondColor', value);
    }
    get secondFraction() {
      return this._getOption('secondFraction');
    }
    set secondFraction(value) {
      this._setOption('secondFraction', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get spindleGapSize() {
      return this._getOption('spindleGapSize');
    }
    set spindleGapSize(value) {
      this._setOption('spindleGapSize', value);
    }
    get spindleSize() {
      return this._getOption('spindleSize');
    }
    set spindleSize(value) {
      this._setOption('spindleSize', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'subvalueIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeSubvalueIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeSubvalueIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeSubvalueIndicatorComponent,
      selectors: [["dxo-circular-gauge-subvalue-indicator"]],
      inputs: {
        arrowLength: "arrowLength",
        backgroundColor: "backgroundColor",
        baseValue: "baseValue",
        beginAdaptingAtRadius: "beginAdaptingAtRadius",
        color: "color",
        horizontalOrientation: "horizontalOrientation",
        indentFromCenter: "indentFromCenter",
        length: "length",
        offset: "offset",
        palette: "palette",
        secondColor: "secondColor",
        secondFraction: "secondFraction",
        size: "size",
        spindleGapSize: "spindleGapSize",
        spindleSize: "spindleSize",
        text: "text",
        type: "type",
        verticalOrientation: "verticalOrientation",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeSubvalueIndicatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeSubvalueIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeSubvalueIndicatorModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeSubvalueIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeSubvalueIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeSubvalueIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeSubvalueIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeSubvalueIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeTextComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeTextComponent extends NestedOption {
    get customizeText() {
      return this._getOption('customizeText');
    }
    set customizeText(value) {
      this._setOption('customizeText', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get indent() {
      return this._getOption('indent');
    }
    set indent(value) {
      this._setOption('indent', value);
    }
    get _optionPath() {
      return 'text';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeTextComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeTextComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeTextComponent,
      selectors: [["dxo-circular-gauge-text"]],
      inputs: {
        customizeText: "customizeText",
        font: "font",
        format: "format",
        indent: "indent"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeTextComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeTextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeTextModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeTextModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeTextModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeTextModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeTextModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeTextModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeTickComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeTickComponent extends NestedOption {
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'tick';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeTickComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeTickComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeTickComponent,
      selectors: [["dxo-circular-gauge-tick"]],
      inputs: {
        color: "color",
        length: "length",
        opacity: "opacity",
        visible: "visible",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeTickComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeTickComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeTickModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeTickModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeTickModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeTickModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeTickModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeTickModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeTitleComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeTitleComponent extends NestedOption {
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get horizontalAlignment() {
      return this._getOption('horizontalAlignment');
    }
    set horizontalAlignment(value) {
      this._setOption('horizontalAlignment', value);
    }
    get margin() {
      return this._getOption('margin');
    }
    set margin(value) {
      this._setOption('margin', value);
    }
    get placeholderSize() {
      return this._getOption('placeholderSize');
    }
    set placeholderSize(value) {
      this._setOption('placeholderSize', value);
    }
    get subtitle() {
      return this._getOption('subtitle');
    }
    set subtitle(value) {
      this._setOption('subtitle', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get textOverflow() {
      return this._getOption('textOverflow');
    }
    set textOverflow(value) {
      this._setOption('textOverflow', value);
    }
    get verticalAlignment() {
      return this._getOption('verticalAlignment');
    }
    set verticalAlignment(value) {
      this._setOption('verticalAlignment', value);
    }
    get wordWrap() {
      return this._getOption('wordWrap');
    }
    set wordWrap(value) {
      this._setOption('wordWrap', value);
    }
    get _optionPath() {
      return 'title';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeTitleComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeTitleComponent,
      selectors: [["dxo-circular-gauge-title"]],
      inputs: {
        font: "font",
        horizontalAlignment: "horizontalAlignment",
        margin: "margin",
        placeholderSize: "placeholderSize",
        subtitle: "subtitle",
        text: "text",
        textOverflow: "textOverflow",
        verticalAlignment: "verticalAlignment",
        wordWrap: "wordWrap"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeTitleComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeTitleModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeTitleModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeTitleModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeTitleModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeTitleModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeTooltipComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeTooltipComponent extends NestedOption {
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get border() {
      return this._getOption('border');
    }
    set border(value) {
      this._setOption('border', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get cornerRadius() {
      return this._getOption('cornerRadius');
    }
    set cornerRadius(value) {
      this._setOption('cornerRadius', value);
    }
    get customizeTooltip() {
      return this._getOption('customizeTooltip');
    }
    set customizeTooltip(value) {
      this._setOption('customizeTooltip', value);
    }
    get enabled() {
      return this._getOption('enabled');
    }
    set enabled(value) {
      this._setOption('enabled', value);
    }
    get font() {
      return this._getOption('font');
    }
    set font(value) {
      this._setOption('font', value);
    }
    get format() {
      return this._getOption('format');
    }
    set format(value) {
      this._setOption('format', value);
    }
    get interactive() {
      return this._getOption('interactive');
    }
    set interactive(value) {
      this._setOption('interactive', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get paddingLeftRight() {
      return this._getOption('paddingLeftRight');
    }
    set paddingLeftRight(value) {
      this._setOption('paddingLeftRight', value);
    }
    get paddingTopBottom() {
      return this._getOption('paddingTopBottom');
    }
    set paddingTopBottom(value) {
      this._setOption('paddingTopBottom', value);
    }
    get shadow() {
      return this._getOption('shadow');
    }
    set shadow(value) {
      this._setOption('shadow', value);
    }
    get zIndex() {
      return this._getOption('zIndex');
    }
    set zIndex(value) {
      this._setOption('zIndex', value);
    }
    get _optionPath() {
      return 'tooltip';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeTooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeTooltipComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeTooltipComponent,
      selectors: [["dxo-circular-gauge-tooltip"]],
      inputs: {
        arrowLength: "arrowLength",
        border: "border",
        color: "color",
        container: "container",
        contentTemplate: "contentTemplate",
        cornerRadius: "cornerRadius",
        customizeTooltip: "customizeTooltip",
        enabled: "enabled",
        font: "font",
        format: "format",
        interactive: "interactive",
        opacity: "opacity",
        paddingLeftRight: "paddingLeftRight",
        paddingTopBottom: "paddingTopBottom",
        shadow: "shadow",
        zIndex: "zIndex"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeTooltipComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeTooltipComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeTooltipModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeTooltipModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeTooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeTooltipModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeTooltipModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeTooltipModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoCircularGaugeValueIndicatorComponent = /*#__PURE__*/(() => {
  class DxoCircularGaugeValueIndicatorComponent extends NestedOption {
    get arrowLength() {
      return this._getOption('arrowLength');
    }
    set arrowLength(value) {
      this._setOption('arrowLength', value);
    }
    get backgroundColor() {
      return this._getOption('backgroundColor');
    }
    set backgroundColor(value) {
      this._setOption('backgroundColor', value);
    }
    get baseValue() {
      return this._getOption('baseValue');
    }
    set baseValue(value) {
      this._setOption('baseValue', value);
    }
    get beginAdaptingAtRadius() {
      return this._getOption('beginAdaptingAtRadius');
    }
    set beginAdaptingAtRadius(value) {
      this._setOption('beginAdaptingAtRadius', value);
    }
    get color() {
      return this._getOption('color');
    }
    set color(value) {
      this._setOption('color', value);
    }
    get horizontalOrientation() {
      return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value) {
      this._setOption('horizontalOrientation', value);
    }
    get indentFromCenter() {
      return this._getOption('indentFromCenter');
    }
    set indentFromCenter(value) {
      this._setOption('indentFromCenter', value);
    }
    get length() {
      return this._getOption('length');
    }
    set length(value) {
      this._setOption('length', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get palette() {
      return this._getOption('palette');
    }
    set palette(value) {
      this._setOption('palette', value);
    }
    get secondColor() {
      return this._getOption('secondColor');
    }
    set secondColor(value) {
      this._setOption('secondColor', value);
    }
    get secondFraction() {
      return this._getOption('secondFraction');
    }
    set secondFraction(value) {
      this._setOption('secondFraction', value);
    }
    get size() {
      return this._getOption('size');
    }
    set size(value) {
      this._setOption('size', value);
    }
    get spindleGapSize() {
      return this._getOption('spindleGapSize');
    }
    set spindleGapSize(value) {
      this._setOption('spindleGapSize', value);
    }
    get spindleSize() {
      return this._getOption('spindleSize');
    }
    set spindleSize(value) {
      this._setOption('spindleSize', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get verticalOrientation() {
      return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value) {
      this._setOption('verticalOrientation', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get _optionPath() {
      return 'valueIndicator';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoCircularGaugeValueIndicatorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeValueIndicatorComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoCircularGaugeValueIndicatorComponent,
      selectors: [["dxo-circular-gauge-value-indicator"]],
      inputs: {
        arrowLength: "arrowLength",
        backgroundColor: "backgroundColor",
        baseValue: "baseValue",
        beginAdaptingAtRadius: "beginAdaptingAtRadius",
        color: "color",
        horizontalOrientation: "horizontalOrientation",
        indentFromCenter: "indentFromCenter",
        length: "length",
        offset: "offset",
        palette: "palette",
        secondColor: "secondColor",
        secondFraction: "secondFraction",
        size: "size",
        spindleGapSize: "spindleGapSize",
        spindleSize: "spindleSize",
        text: "text",
        type: "type",
        verticalOrientation: "verticalOrientation",
        width: "width"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoCircularGaugeValueIndicatorComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxoCircularGaugeValueIndicatorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoCircularGaugeValueIndicatorModule = /*#__PURE__*/(() => {
  class DxoCircularGaugeValueIndicatorModule {
    /** @nocollapse */static ɵfac = function DxoCircularGaugeValueIndicatorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoCircularGaugeValueIndicatorModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoCircularGaugeValueIndicatorModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
  return DxoCircularGaugeValueIndicatorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 24.2.8
 * Build date: Fri Jun 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiCircularGaugeRangeComponent, DxiCircularGaugeRangeModule, DxoCircularGaugeAnimationComponent, DxoCircularGaugeAnimationModule, DxoCircularGaugeBackgroundColorComponent, DxoCircularGaugeBackgroundColorModule, DxoCircularGaugeBorderComponent, DxoCircularGaugeBorderModule, DxoCircularGaugeColorComponent, DxoCircularGaugeColorModule, DxoCircularGaugeExportComponent, DxoCircularGaugeExportModule, DxoCircularGaugeFontComponent, DxoCircularGaugeFontModule, DxoCircularGaugeFormatComponent, DxoCircularGaugeFormatModule, DxoCircularGaugeGeometryComponent, DxoCircularGaugeGeometryModule, DxoCircularGaugeLabelComponent, DxoCircularGaugeLabelModule, DxoCircularGaugeLoadingIndicatorComponent, DxoCircularGaugeLoadingIndicatorModule, DxoCircularGaugeMarginComponent, DxoCircularGaugeMarginModule, DxoCircularGaugeMinorTickComponent, DxoCircularGaugeMinorTickModule, DxoCircularGaugeRangeContainerComponent, DxoCircularGaugeRangeContainerModule, DxoCircularGaugeScaleComponent, DxoCircularGaugeScaleModule, DxoCircularGaugeShadowComponent, DxoCircularGaugeShadowModule, DxoCircularGaugeSizeComponent, DxoCircularGaugeSizeModule, DxoCircularGaugeSubtitleComponent, DxoCircularGaugeSubtitleModule, DxoCircularGaugeSubvalueIndicatorComponent, DxoCircularGaugeSubvalueIndicatorModule, DxoCircularGaugeTextComponent, DxoCircularGaugeTextModule, DxoCircularGaugeTickComponent, DxoCircularGaugeTickModule, DxoCircularGaugeTitleComponent, DxoCircularGaugeTitleModule, DxoCircularGaugeTooltipComponent, DxoCircularGaugeTooltipModule, DxoCircularGaugeValueIndicatorComponent, DxoCircularGaugeValueIndicatorModule };
